export enum BlotterType {
  ORDER,
  TRADE,
  POSITION,
  INTERVENTION,
  SCRATCHPAD,
  BENCHMARK,
  FWD_RISK,
  OPSINTERVENTION,
  RISKTRADE,
  ALGO_RISK_TRADE,
  ALLOCATION,
}

export namespace BlotterType {
  let elements = [
    BlotterType.ORDER,
    BlotterType.TRADE,
    BlotterType.POSITION,
    BlotterType.INTERVENTION,
    BlotterType.SCRATCHPAD,
    BlotterType.BENCHMARK,
    BlotterType.FWD_RISK,
    BlotterType.OPSINTERVENTION,
    BlotterType.RISKTRADE,
    BlotterType.ALGO_RISK_TRADE,
    BlotterType.ALLOCATION,
  ];
  let alias = "com.bcdfx.model.BlotterType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
